// Load all product JSON files from src/content/products/
const productContext = require.context('../content/products', false, /\.json$/);

const products = productContext.keys().map((key) => {
  const product = productContext(key);

  return {
    ...product,
    seoTitle:
      product.seoTitle || `${product.namn} | Cycle Solutions`,
    seoDescription:
      product.seoDescription ||
      product.beskrivning ||
      'Balpressar och komprimatorer från Cycle Solutions.'
  };
});

export default products;
